export const HeaderConstants = {
  buttons: [
    {
      icon: 'fa-envelope',
      component: 'app-inbox',
      id: 'inbox',
      url: 'inbox/current',
      badge: 4,
      badgeActive: true,
      class: '',
    },
    {
      icon: 'fa-mobile-alt',
      component: 'app-offline',
      id: 'offline',
      url: 'offline',
      badge: 10,
      badgeActive: false,
      class: 'downloaded',
    },
    {
      icon: 'fa-heart',
      component: 'app-favorite',
      id: 'favorite',
      url: 'inbox/favorite',
      badge: 10,
      badgeActive: false,
      class: 'router-favorite',
    },
    {
      icon: 'fa-user-cog',
      component: 'app-settings',
      id: 'settings',
      url: 'user',
      badge: null,
      badgeActive: false,
      class: '',
    },
  ],
};
